module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/1@2x_c855091923c946834d7396c0d7773899.png";